<template>
    <!--跟进状态-->
    <el-select class="ele-select" :disabled="disabled" :value-key="type=='object'?'dicCode':''" :clearable="clearable" @visible-change="visiblechange" @change="change" :size="size" :value="value" :placeholder="placeholder">
        <el-option
                v-for="item in list"
                :key="item.dicCode"
                :label="item.dicName"
                v-if="hidestate?item.dicCode!='01':item.dicCode!=''"
                :value="type=='object'?item:item.dicCode">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "follow-state",
        props:{
            type:String,
            size:String,
            disabled:Boolean,
            placeholder:String,
            clearable:Boolean,
            value:String|Object,
            hidestate:Boolean
        },
        model:{
            prop:'value',
            event:'input'
        },
        data(){
            return{
                list:[],

            }
        },
        watch:{
            value(newval,oldval){
                var code=this.type=='object'?newval.dicCode:newval;
                var list=this.list.filter((item)=>item.dicCode==code);
                //数据不存在时
                if(list.length==0){
                    this.$store.state.dicChange=true;
                    this.getData();
                }

            }
        },
        mounted(){
            this.getData();
        },
        methods:{
            getData(){
                if(this.$root.getStorage('dic')){
                    this.list=this.$root.getStorage('dic').filter((item)=>item.dicType=='follow_state');
                }else{
                    this.$store.state.dicChange=true;
                }
            },
            visiblechange(isshow){
                console.log(isshow)
                if(isshow){
                    // this.getData();
                }
            },
            change(value){
                console.log(value)
                this.$emit('input',value);
            }
        }
    }
</script>

<style scoped>

</style>